import { createFileRoute } from "@tanstack/react-router";
import { OperatorsPanel } from "../../../workspaces/settings/OperatorsPanel";

export const Route = createFileRoute("/_console/settings/operators")({
  component: OperatorsPanel,
});
